<template>
<div class='avatar-main'>
    <input id='file'
           type='file'
           name='file'
           class='inputfile'
           @change='onFileChange'>
    <label class='h-flex-center'
           :style='{
               display: `flex`,
               background: backgroundColor,
               backgroundImage: `url(${image})`,
               backgroundSize: `cover`,
               backgroundRepeat: `no-repeat`,
               backgroundPosition: `center`,
           }'
           for='file'>
        <div class='avatar-photo'>
            <FwIcon :icon='iconImg'
                    size='30'
                    color='#ffffff'>
            </FwIcon>
        </div>
    </label>
    <div v-if='uploadButton' class='h-mt-20'>
        <h2 class='h-font-26 h-text-center'>
            {{ titleTxt }}
        </h2>
        <div v-if='image'>
            <p class='h-font-18 h-text-center'>
                {{ descriptionTxtSuccess }}
            </p>
            <div class='h-mt-30 h-flex h-flex-dir-column h-flex-center'>
                <FwButton class='h-mt-20'
                          borderRadiusType='tiny-border'
                          :disabled='isRequestSending'
                          @click='goNextPageHandler'>
                    {{ buttonTxtSuccess }}
                </FwButton>
                <input type='file'
                       name='file'
                       class='inputfile-btn-success'
                       placeholder='Import a photo'
                       @change='onFileChange'>
                <label class='h-mt-30' for='file'>
                    {{ buttonUploadSuccess }}
                </label>
            </div>
        </div>
        <div v-else>
            <p class='h-font-18 h-text-center'>
                {{ descriptionTxt }}
            </p>
            <div class='h-mt-30 h-text-center'>
                <input type='file'
                       name='file'
                       class='inputfile-btn'
                       placeholder='Import a photo'
                       @change='onFileChange'>
                <label for='file'>
                    {{ buttonTxt }}
                </label>
            </div>
        </div>
    </div>
    <div v-if='error' class='input_hint--error'>
        {{ errorMessage }}
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component

export default class FwAvatarUpload extends Vue {
    @Prop({ type: String, default: '' }) readonly backgroundImg!: string;
    @Prop({ type: String, default: '' }) readonly titleTxt!: string;
    @Prop({ type: String, default: '' }) readonly descriptionTxt!: string;
    @Prop({ type: String, default: '' }) readonly descriptionTxtSuccess!: string;
    @Prop({ type: String, default: '' }) readonly errorMessage!: string;
    @Prop({ type: String, default: '' }) readonly buttonTxt!: string;
    @Prop({ type: String, default: '' }) readonly buttonTxtSuccess!: string;
    @Prop({ type: String, default: '' }) readonly buttonUploadSuccess!: string;
    @Prop({ type: String, default: '#d8dee5' }) readonly backgroundColor!: string;
    @Prop({ type: String, default: 'photo-icon' }) readonly iconImg!: string;
    @Prop({ type: Boolean, default: false }) readonly uploadButton!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isRequestSending!: boolean;

    image: null | string | ArrayBuffer = null;
    error: string = '';

    onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;
        this.createImage(files[0]);
    }

    createImage(file: File) {
        const reader = new FileReader();
        this.error = '';
        reader.onload = (e: any) => {
            const FileSize = file.size / 1024 / 1024;
            if (FileSize > 1) {
                this.error = 'File size exceeds 1 MB';
                this.image = null;
            } else {
                this.image = e.target.result;
                this.$emit('upload', file);
            }
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    }

    created() {
        this.image = this.backgroundImg;
    }

    goNextPageHandler() {
        if (this.isRequestSending) {
            return;
        }
        this.$emit(`goNextPage`);
    }
};
</script>

<style lang='sass'>
.avatar-main
    width: 100%
    position: relative
    display: flex
    flex-flow: column nowrap
    justify-content: center
    align-items: center
.inputfile
    width: 0.1px
    height: 0.1px
    opacity: 0
    overflow: hidden
    position: absolute
    z-index: -1

.avatar-photo
    position: absolute
.inputfile + label
    position: relative
    font-size: 1.25em
    font-weight: 700
    color: white
    opacity: 0.7
    width: 100px
    height: 100px
    margin-bottom: 0
    border-radius: 50%
    display: inline-block
    transition: opacity 0.25s ease-in-out
.inputfile + label:hover
    opacity: 0.8

.inputfile + label
    cursor: pointer
.inputfile:focus + label
    outline: none
.inputfile + label *
    pointer-events: none
.input_hint--error
    font-size: 14px
    font-weight: 500
    color: #ff004d
    width: 100%
    bottom: -5px
    text-align: center
.inputfile-btn + label
    background-color: #27dbbd
    border-color: #27dbbd
    border: none
    border-radius: 10px
    color: #fff
    cursor: pointer
    display: inline-block
    font-size: inherit
    font-weight: 600
    margin-bottom: 1rem
    outline: none
    padding: 1rem 30px
    position: relative
    transition: all 0.3s
    vertical-align: middle
    &:hover
        background-color: #37e6c9
        border-color: #37e6c9
.inputfile-btn-success + label
    font-size: 16px
    font-weight: 500
    color: rgba(33,63,107,.3)
    background-color: transparent
    border-color: transparent
    border: none
    border-radius: 10px
    cursor: pointer
    display: inline-block
    margin-bottom: 1rem
    outline: none
    padding: 1rem 30px
    position: relative
    transition: all 0.3s
    vertical-align: middle
.inputfile-btn, .inputfile-btn-success
    height: 0
    overflow: hidden
    width: 0
    background-color: #f79159
    box-shadow: 0 6px darken(#f79159, 10%)
    transition: none
</style>

